<script lang="ts">
	import { fade } from 'svelte/transition';
	import { flip } from 'svelte/animate';
	import { XMark } from 'svelte-heros-v2';

	import { removeToast, toasts } from '$lib/stores/toasts';
	import ToastIcon from './ToastIcon.svelte';
	import ToastProgress from './ToastProgress.svelte';
</script>

{#if $toasts}
	<div
		class="fixed top-4 right-1/2 z-[55] flex flex-col-reverse gap-4 sm:top-8 sm:right-8 w-full max-w-xs translate-x-1/2 sm:translate-x-0"
	>
		{#each $toasts as { id, title, message, type, time } (id)}
			<div
				in:fade
				animate:flip={{ duration: 300 }}
				role="alert"
				class="relative overflow-hidden rounded-md bg-white shadow-lg"
			>
				<div class="p-4">
					<div class="flex items-center">
						<ToastIcon toastType={type} />
						{#if title || message}
							<div
								class="ml-3 border-l border-neutral-200 px-3 text-sm flex flex-col justify-center"
							>
								{#if title}<p class="font-semibold text-neutral-900">{title}</p>{/if}
								{#if message}<p class="font-normal text-neutral-700">{message}</p>{/if}
							</div>
						{/if}
					</div>
					<button
						class="absolute top-2 right-2 rounded-full bg-white p-1 hover:bg-neutral-100 focus-visible:bg-neutral-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-neutral-900"
						on:click={() => removeToast(id)}
					>
						<XMark class="text-neutral-900 outline-none" size="20" />
						<span class="sr-only">Убрать уведомление</span>
					</button>
				</div>
				<ToastProgress toastType={type} animationTime={time / 1000 + 's'} />
			</div>
		{/each}
	</div>
{/if}
